
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({
  emits: ["update:isChecked"],
}) class CustomCheckbox extends Vue {
  @Prop({ required: false, default: "" }) public title!: string;
  @Prop({ default: false }) public isChecked!: boolean;
  @Prop({ default: false }) public disabled?: boolean;
  @Prop({ required: false, default: "" }) readonly id: string = "";
  @Prop({ required: false, default: "" }) readonly type: string = "";
  @Prop({ required: false, default: "" }) readonly name: string = "";
  @Prop({ required: false, default: "24px" }) readonly size: string = "24px";
  @Prop({ required: false, default: "transparent" }) readonly bgColor: string =
    "";
  @Prop({ required: false, default: false })
  readonly isForceSelect: boolean = false;
  @Prop({ required: false, default: "#387dff" })
  readonly colorCheckmark: string = "";
  @Prop({ required: false, default: "40px" })
  public paddingLeftCheckbox = "40px";
}

const __default__ = CustomCheckbox
import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "222034c4": (_ctx.paddingLeftCheckbox),
  "2347f862": (_ctx.colorCheckmark)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__